import { IChild, initialChild } from "./children";
import { IAbductor } from "./abductor";

export enum CheckCaseId {
    NoCheck,
    Typing,
    Checking,
    Valid,
    Invalid,
    InvalidCharacter
}

export enum CaseTypes {
    EndangeredMiss = 'Endangered Missing',
    FamilyAbduction = 'Family Abduction',
    LostInjuredMiss = 'Lost Injured Missing',
    NonFamilyAbduction = 'Non-Family Abduction',
    Unidentified = 'Unidentified',
    Unknown = 'Unknown'
}
export enum CloseCaseReason {
    ALIVE = "ALIVE",
    DECEASED = "DECEASED",
    NOPUBLICITY = "NOPUBLICITY",
    UNKNOWN = "UNKNOWN"
}
export const closeCaseTypes: Partial<{ [key in keyof typeof CloseCaseReason]: string }> = {
    [CloseCaseReason.ALIVE]: "The child has been recovered - Alive",
    [CloseCaseReason.DECEASED]: "The child has been recovered - Deceased",
    [CloseCaseReason.NOPUBLICITY]: "Case no longer needs publicity",
    [CloseCaseReason.UNKNOWN]: "Unknown"
}
export interface IClosedCasesBulkProps {
    history: { push: (path: string) => void },
    location: { search: { from: string; to: string; }}
  }
export interface IClosedCasesToBulk {
    [caseId: string]: Partial<ICase>
}
export interface ICase {
    agencyCode: string;
    contactInformation: string;
    caseId: string;
    caseType: CaseTypes;
    poster: string;
    public: boolean;
    status: string;
    openDate?: any;
    circumstances: string;
    country: string;
    state: string;
    city: string;
    address: string;
    children: IChild[];
    childrenIds?: string[];
    abductors: IAbductor[];
    abductorsIds?: string[];
    providers?: IListProviders;
    sendMatches: string;
    closedDate?: any;
    closeReason?: CloseCaseReason;
    closedComments?: string;
    miscellaneous?: string[];
    lastSeen?: string;
    missingDate: any;
    agenciesAccess?: string[];
    etl?: boolean;
}

export interface IListProviders {
    [key: string]: { threshold: number, checked: boolean };
}

export const initialCase: ICase =
{
    agencyCode: '',
    contactInformation: '',
    caseId: '',
    caseType: CaseTypes.EndangeredMiss,
    poster: 'Missing',
    public: true,
    status: 'open',
    // circumstances
    circumstances: "",
    country: "",
    state: "",
    city: "",
    address: "",
    children: [{ ...initialChild }],
    abductors: [],
    sendMatches: '',
    closedDate: '',
    closedComments: '',
    miscellaneous: [],
    lastSeen: "",
    missingDate: ''
}



// WEBPACK FOOTER //
// ./src/share/types/case/case.ts